import React, { useState, useRef } from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    IconButton,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Box,
    Text,
    Tooltip,
    Icon,
    Select,  
    InputRightElement,
    InputGroup,
    Textarea,
} from '@chakra-ui/react';
import { VscEdit } from 'react-icons/vsc';
import { MdDelete, MdAssignmentAdd } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { ToastChakra } from '../../helpers/toast';
import { getClienteByDni } from '../../features/clienteSlice';
import { getFacturas, updateFactura } from '../../features/facturaVentaSlice';
import { Search2Icon } from '@chakra-ui/icons';
import { ModalAgregarClienteFactura } from '../cliente/ModalAgregarClienteFactura';

export const ModalEditarFactura = ({ row ,page, perPage }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalClienteOpen, setIsModalClienteOpen] = useState(false); 
  const handleModalClienteClose = () => setIsModalClienteOpen(false);
  const [editIndex, setEditIndex] = useState(null);
  const descripcionRef = useRef(null);

  const initialValues = {
    nroFactura: '',
    fechaFactura: '',
    cliente: '',
    direccion: '',
    clienteId: '',
    dni: '',
    descripcion: '',
    estado: '',
    iva: 21,
    precioUnitario: '',
    cantidad: '',
    observaciones: '',
    condicionPago: '',
  };

  const [indice, setIndice] = useState(initialValues);
  const [servicios, setServicios] = useState([]);

// Formatear el precio a moneda con separadores de miles
const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true, // 🔹 Esto activa los puntos de miles
    }).format(value);
  };

  const handleModalOpen = () => {
    if (!row) return;

    // Verifica si el estado es "PENDIENTE"
   /* if (row.estado !== "PENDIENTE") {
        ToastChakra(
            "Acción no permitida",
            "Solo se pueden editar facturas en estado PENDIENTE.",
            "warning",
            4000,
            "bottom-right"
        );
        return; // Detiene la ejecución si el estado no es "PENDIENTE"
    } */


    const estadoMap = {
        ACTIVO: "AC",
        PENDIENTE: "PE",
    };

    const condicionPagoMap = {
        CONTADO: "CO",
        CREDITO: "CR",
    };
    setIndice({
      nroFactura: row.numero,
      fechaFactura: row.fechaFactura,
      cliente: row.cliente,
      direccion: row.direccion,
      dni: row.dni,
      clienteId: row.clienteId || '',
      descripcion: '',
      estado: estadoMap[row.estado] || '', // Mapea el estado al formato esperado por el <Select>
      condicionPago: condicionPagoMap[row.condicionPago] || '', // Mapea la condición de pago
      iva: 21,
      precioUnitario: '0',
      cantidad: '1',
      observaciones : row.observaciones || '',
    });

    const detallesConvertidos = row.detalles.map((item) => ({
      descripcion: item.descripcion,
      cantidad: Number(item.cantidad),
      precioUnitario: Number(item.precio_unitario),
      iva: Number(item.iva),
      precioTotal: Number(item.precio_total),
    }));

    setServicios(detallesConvertidos);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditIndex(null);
    setIndice(initialValues);
    setServicios([]);
  };

  const handleBuscarCliente = () => {
    if (!indice.dni.trim()) {
      ToastChakra('ERROR', 'Por favor, ingrese un DNI/RUC válido.', 'error', 3000, 'bottom-right');
      return;
    }

    dispatch(getClienteByDni(indice.dni)).then((response) => {
      const cliente = response.payload;
      if (cliente && cliente.success) {
        setIndice((prev) => ({
          ...prev,
          cliente: cliente.nombre,
          direccion: cliente.direccion,
          clienteId: cliente.id,
        }));
      } else {
        setIndice((prev) => ({ ...prev, cliente: '', clienteId: '', direccion: '' }));
      }
    });
  };

  const handleAgregarServicio = () => {
      if (!indice.descripcion || !indice.cantidad || !indice.precioUnitario || !indice.iva) {
                ToastChakra('ERROR', 'Por favor, complete todos los campos del servicio.', 'error', 3000, 'bottom-right');
                //alert("Por favor, complete todos los campos del servicio.");
                return;
      }

    const precioTotal = indice.cantidad * indice.precioUnitario * (1 + indice.iva / 100);

    if (editIndex !== null) {
      const nuevosServicios = [...servicios];
      nuevosServicios[editIndex] = {
        descripcion : indice.descripcion,
        cantidad : indice.cantidad,
        precioUnitario : indice.precioUnitario,
        iva : indice.iva,
        precioTotal: parseFloat(precioTotal.toFixed(2)),
      };
      setServicios(nuevosServicios);
      setEditIndex(null);
    } else {
      setServicios([
        {
          descripcion: indice.descripcion,
          cantidad : indice.cantidad,
          precioUnitario : indice.precioUnitario,
          iva : indice.iva,
          precioTotal: parseFloat(precioTotal.toFixed(2)),
        },
        ...servicios, // los anteriores se agregan después
      ]);
    }

    setIndice({ ...indice, descripcion: '', cantidad: '1', precioUnitario: '0' });

    setTimeout(() => {
      descripcionRef.current?.focus();
    }, 0);
  };

  const handleEditarServicio = (index) => {
    const servicio = servicios[index];
    setIndice({
      ...indice,
      descripcion: servicio.descripcion,
      cantidad: servicio.cantidad,
      precioUnitario: servicio.precioUnitario,
      iva: servicio.iva,
    });
    setEditIndex(index);
    setTimeout(() => descripcionRef.current?.focus(), 0);
  };

  const handleEliminarServicio = (index) => {
    const nuevosServicios = servicios.filter((_, i) => i !== index);
    setServicios(nuevosServicios);
  };

  const totalBase = servicios.reduce((acc, s) => acc + s.cantidad * s.precioUnitario, 0);
  const totalIVA = servicios.reduce((acc, s) => acc + (s.cantidad * s.precioUnitario * s.iva) / 100, 0);
  const totalGeneral = totalBase + totalIVA;

  const handleUpdate = () => {
    // Recupera el usuario desde el localStorage
    const user = JSON.parse(localStorage.getItem('user'));
    const usuarioId = user?.usuario?.id;

    if (!usuarioId) {
        ToastChakra(
            "Error",
            "No se pudo obtener el ID del usuario. Por favor, inicie sesión nuevamente.",
            "error",
            3000,
            "bottom-right"
        );
        return;
    }

    // Construye el objeto de datos para enviar al backend
    const datosFactura = {
        id: row.id, // ID de la factura a actualizar
        nroFactura: indice.nroFactura,
        fechaFactura: indice.fechaFactura,
        clienteId: indice.clienteId,
        estado: indice.estado,
        condicionPago: indice.condicionPago,
        observaciones: indice.observaciones,
        usuarioId: usuarioId, // Incluye el ID del usuario
        totalGeneral: totalGeneral.toFixed(2), // Calcula el total general
        detalles: servicios.map((servicio) => ({
            descripcion: servicio.descripcion,
            cantidad: servicio.cantidad,
            precioUnitario: servicio.precioUnitario,
            iva: servicio.iva,
            precioTotal: servicio.precioTotal,
        })),
    };

   // console.log("Datos enviados al backend:", datosFactura); // Depuración

    // Envía los datos al backend
    dispatch(updateFactura(datosFactura))
        .then(() => {
            // Actualiza la tabla después de guardar
            dispatch(getFacturas({ page, perPage }));
            // Cierra el modal y reinicia los estados
            setIsModalOpen(false);
            setIndice(initialValues);
            setServicios([]);
        })
        .catch((error) => {
            console.error("Error al actualizar la factura:", error);
        });
 };

  return (
    <>
       <Tooltip hasArrow label='Editar' placement='auto'>
                      <IconButton
                          colorScheme="blackAlpha"
                          _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                          aria-label="Editar"
                          icon={<Icon as={VscEdit}
                              fontSize="2xl" />}
                          variant="ghost"
                          onClick={() => handleModalOpen(row)}
                          ml={2}
                      />
      </Tooltip>
      <Modal isOpen={isModalOpen} onClose={handleModalClose} isCentered>
        <ModalOverlay
            bg="rgba(11,15,25, 0.8)"
            backdropFilter='auto'
            backdropBlur='2px'
        />
        <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl" maxWidth="90%">
          <ModalHeader textAlign="center">Editar Factura</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* Contenedor principal */}
            <Stack spacing={2} direction="column" p={4}> {/* Reduce el spacing entre los Stack */}
               {/* Primer Stack */}
                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                    <FormControl isRequired>
                        <FormLabel fontWeight="semibold" fontSize="xs">NRO. FACTURA</FormLabel>
                        <Input
                           type="text"
                           size="sm" 
                           value={indice.nroFactura} isReadOnly 
                        />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel fontWeight={'semibold'} fontSize="xs">FECHA DE EMISIÓN</FormLabel>
                        <Input 
                            type="date" 
                            size="sm"
                            value={indice.fechaFactura} 
                            onChange={(e) => setIndice({ ...indice, fechaFactura: e.target.value })} />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel fontWeight={'semibold'}fontSize="xs">CONDICION DE PAGO</FormLabel>
                        <Select
                            size="sm"
                            onChange={(e) => setIndice({ ...indice, condicionPago: e.target.value })}
                            value={indice.condicionPago} // Muestra la condición de pago seleccionada
                        >
                            <option value="CO">CONTADO</option>
                            <option value="CRE">CRÉDITO</option>
                        </Select>
                    </FormControl>  

                    <FormControl isRequired>
                        <FormLabel fontWeight={'semibold'}fontSize="xs">ESTADO</FormLabel>
                        <Select
                            size="sm"
                            onChange={(e) => setIndice({ ...indice, estado: e.target.value })}
                            value= {indice.estado} // Sincroniza con el estado  
                        >
                            <option value="AC">ACTIVO</option>
                            <option value="PE">PENDIENTE</option>
                        </Select>
                    </FormControl>  

                </Stack>
                 {/* Segundo Stack */}
                 <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                    <FormControl isRequired flex="1">
                        <FormLabel fontWeight="semibold" fontSize="xs">DNI/RUC</FormLabel>
                        <InputGroup size="sm">
                            <Input
                                type="text"
                                placeholder="Ingrese dni/ruc"
                                size="sm"
                                value={indice.dni}
                                onChange={(e) => setIndice({ ...indice, dni: e.target.value })}
                                
                            />
                            <InputRightElement width="2.5rem">
                                <Tooltip hasArrow label="Buscar por dni/ruc" placement="auto">
                                    <IconButton
                                        aria-label="Buscar"
                                        rounded="full"
                                        size="xs"
                                        icon={<Icon as={Search2Icon} fontSize="md" />}
                                        colorScheme="green"
                                        variant="solid"
                                        onClick={handleBuscarCliente} // Llama a la función para buscar el cliente
                                    />
                                </Tooltip>
                            </InputRightElement>
                        </InputGroup>
                    </FormControl>

                    <FormControl flex="2">
                       <FormLabel fontWeight="semibold" fontSize="xs">CLIENTE</FormLabel>
                       <Input
                            type="text"
                            placeholder="Nombre del cliente"
                            size="sm"
                            value={indice.cliente} // Muestra el nombre del cliente
                            isReadOnly // Hace que el campo sea de solo lectura
                        />
                    </FormControl>

                    <FormControl flex="2">
                       <FormLabel fontWeight="semibold" fontSize="xs">DIRECCION</FormLabel>
                       <Input
                            type="text"
                            placeholder="Direccion del cliente"
                            size="sm"
                            value={indice.direccion} // Muestra el nombre del cliente
                            isReadOnly // Hace que el campo sea de solo lectura
                        />
                    </FormControl>
                    {/* Modal para agregar cliente */}
                    <ModalAgregarClienteFactura
                        isOpen={isModalClienteOpen}
                        onClose={handleModalClienteClose}
                    />
                </Stack>
                {/* Tercer Stack */}
                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                    <FormControl>
                        <FormLabel fontWeight="semibold" fontSize="xs">DESCRIPCION DEL SERVICIO</FormLabel>
                        <Textarea
                            ref={descripcionRef} // Asigna la referencia
                            placeholder="Escribe la descripcion del servicio"
                            type="text"
                            size="sm"
                            rows={1} // Cambia la cantidad de líneas visibles
                            value={indice.descripcion} // Sincroniza con el estado
                            onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                            maxLength={150} // Limita a 150 caracteres

                        />
                        <Text fontSize="xs" color="gray.500" mt={1}>
                        {indice.descripcion.length}/150 caracteres
                        </Text>
                    </FormControl>

                </Stack>
                {/* Cuarto Stack */}
                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                    <FormControl isRequired>
                        <FormLabel fontWeight="semibold" fontSize="xs">CANTIDAD</FormLabel>
                        <Input
                            type="number"
                            placeholder="Ingrese la cantidad"
                            size="sm"
                            value={indice.cantidad} // Sincroniza con el estado
                            onChange={(e) => setIndice({ ...indice, cantidad: e.target.value })}
                        />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel fontWeight="semibold" fontSize="xs">PRECIO UNITARIO</FormLabel>
                        <Input
                            type="number"
                            size="sm"
                            placeholder="Ingrese el Precio Unitario"
                            value={indice.precioUnitario} // Sincroniza con el estado
                            onChange={(e) => setIndice({ ...indice, precioUnitario: e.target.value })}
                        />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel fontWeight="semibold" fontSize="xs">IVA</FormLabel>
                        <Select
                            size="sm"
                            onChange={(e) => setIndice({ ...indice, iva: e.target.value })}
                        >
                            <option value="21">21 %</option>
                            <option value="10">10 %</option>
                            <option value="0">Ninguno</option>
                        </Select>
                    </FormControl>

                    {/* Botón Agregar*/}
                    <FormControl>
                        <Tooltip hasArrow label='Agregar en la tabla' placement='auto'>
                            <IconButton
                                colorScheme="purple"
                                _dark={{ bg: "purple.600", color: "white", _hover: { bg: "purple.700" } }}
                                aria-label="Agregar"
                                icon={<Icon as={MdAssignmentAdd} fontSize="2xl" />}
                                variant="solid"
                                borderRadius={'xl'}
                                onClick={handleAgregarServicio} // Llama a la función para agregar el servicio
                                disabled={!indice.descripcion || !indice.cantidad || !indice.precioUnitario } // Deshabilita si los campos están vacíos
                                alignSelf="center" // Centra el botón verticalmente
                                mt={5} // Agrega margen superior para bajar el botón
                            />
                        </Tooltip>
                    </FormControl>
                </Stack>
                {/* Contenedor de la tabla: Clave para el responsive */}
                      <Box borderWidth="1px" p={3} borderRadius="md">          
                            <Box
                                maxH={servicios.length > 2 ? "200px" : "auto"}
                                overflowY={servicios.length > 2 ? "auto" : "visible"}
                                // APLICA ESTO PARA EL SCROLL HORIZONTAL EN MÓVILES
                                overflowX={{ base: "auto", lg: "visible" }} // Desplazamiento horizontal solo en pantallas pequeñas
                                whiteSpace="nowrap" // Evita que el contenido de la tabla se rompa en varias líneas
                            >
                            <Table variant="simple" size="sm" mt={2}>
                                <Thead>
                                    <Tr>
                                        <Th>Descripción</Th>
                                        <Th>Cantidad</Th>
                                        <Th>Precio Unitario</Th>
                                        <Th>IVA %</Th>
                                        <Th>Total</Th>
                                        <Th>Acciones</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {servicios.map((s, idx) => (
                                    <Tr key={idx}>
                                        <Td fontSize="xs">{s.descripcion}</Td>
                                        <Td fontSize="xs">{s.cantidad}</Td>
                                        <Td fontSize="xs">{formatCurrency(s.precioUnitario)}</Td>
                                        <Td fontSize="xs">{s.iva}%</Td>
                                        <Td fontSize="xs">{formatCurrency(s.precioTotal)}</Td>
                                        <Td fontSize="xs">
                                            {/* Botón de edición */}
                                            <Tooltip hasArrow label='Editar' placement='auto'>
                                                <IconButton 
                                                    colorScheme="blackAlpha"
                                                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                                                    aria-label="Editar"
                                                    icon={<Icon as={VscEdit} fontSize="2xl" />}
                                                    variant="ghost"
                                                    onClick={() => handleEditarServicio(idx)} mr={2} 
                                                    ml={2}
                                                />
                                            </Tooltip>
                                            {/* Botón de eliminación */}
                                            <Tooltip hasArrow label='Eliminar' placement='auto'>
                                                <IconButton 
                                                    aria-label="Eliminar"
                                                    icon={<Icon as={MdDelete} />}
                                                    fontSize="2xl"
                                                    colorScheme="red"
                                                    variant={'ghost'}
                                                    _dark={{ color: "white", _hover: { bg: "red.800" } }}
                                                    onClick={() => handleEliminarServicio(idx)}
                                                    ml={2}
                                                />
                                            </Tooltip>
                                        
                                        </Td>
                                    </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>    
                    </Box>   
                        {/* 👇 Contador debajo de la tabla */}
                        <Text fontSize="sm" mt={2} textAlign="right" color="gray.600" _dark={{ color: "gray.300" }}>
                            Mostrando {servicios.length} {servicios.length === 1 ? 'registro' : 'registros'} 
                        </Text>  
                        {/* Totales */}
                       <Box mt={4} p={4} borderWidth="1px" borderRadius="lg" bg="gray.50" _dark={{ bg: "gray.800" }}>
                           <Stack direction={{ base: "column", md: "row" }}>
                                {/* Columna izquierda: Observaciones */}
                                <FormControl flex="1">
                                    <FormLabel fontWeight="semibold" fontSize="sm">Observaciones</FormLabel>
                                    <Textarea
                                        placeholder="Escribe alguna observación si es necesario"
                                        size="sm"
                                        rows={2} // Cambia la cantidad de líneas visibles
                                        value={indice.observaciones || ''} // Sincroniza con el estado
                                        onChange={(e) => setIndice({ ...indice, observaciones: e.target.value })}
                                        maxLength={100} // Limita a 100 caracteres
                                    />
                                    <Text fontSize="xs" color="gray.500" mt={1}>
                                        {indice.observaciones.length}/100 caracteres
                                    </Text>
                                </FormControl>
                            

                                {/* Columna derecha: Resultados */}
                                <Stack spacing={2} flex="1" alignItems={{ base: "flex-start", md: "flex-end" }}> {/* Alinea los resultados al borde derecho */}
                                    <Text fontSize="sm" fontWeight="bold">
                                        Total Base (sin IVA): <Text as="span" color="green.500">{formatCurrency(totalBase)}</Text>
                                    </Text>
                                    <Text fontSize="sm" fontWeight="bold">
                                        Total IVA: <Text as="span" color="green.500">{formatCurrency(totalIVA)}</Text>
                                    </Text>
                                    <Text fontSize="sm" fontWeight="bold">
                                        Total General: <Text as="span" color="green.500">{formatCurrency(totalGeneral)}</Text>
                                    </Text>
                                </Stack>
                            </Stack>
                        </Box>
                    
                </Stack>
          </ModalBody>

          <ModalFooter mt={-2}> {/* Reduce el margen superior */}
            <Button 
                colorScheme="red"
                _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                size="sm"
                mr={3}
                onClick={handleModalClose}
                borderRadius="xl"
            >
                CANCELAR
            </Button>
            <Button 
                colorScheme="blue"
                _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" } }}
                size="sm"
                mr={3}
                onClick={handleUpdate}
                borderRadius="xl"
                disabled={!indice.fechaFactura.trim() || !indice.dni.trim() || !indice.cliente.trim() || servicios.length === 0}
            >
                GUARDAR
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
